var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"authorized":_vm.authorized,"currentUser":_vm.currentUser,"enabled":_vm.enabled})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }